import React from 'react'
import Responsive from '../../components/Responsive';
import { checkTranslation, conditionalWidth, translate } from '../../utils/useful';
import HttpServices from '../../utils/Http.services';
import * as actions from '../../stores/actionsList';
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import FormViewer from '../../components/FormViewer';
import ButtonAnimated from '../../components/buttons/ButtonAnimated';


class AutomationInfo extends React.Component {
    state = {

        workflowInfoHeaders: [
            { key: 'name', type: 'TextInput', information: { label: '{{lang}}Name', placeholder: '{{lang}}ca.name', hint: "{{lang}}This workflow will be called by this name in the platform", required: true } },
            // TO DO: Needs a spesific API to get the frames which this user has access to their workflows management (Create). and the type of farme should be collection or other frames that can have workflow.
            { key: 'frames', type: 'MultiSelectInput', information: { isSearchable: true, label: '{{lang}}Frames', address: 'getFrames', filter: { applet: "{{appletId}}" }, fields: { title: 'name', value: '_id' }, type: 'api', root: '', placeholder: '{{lang}}Frames', required: false } },
            { key: 'default', type: 'SwitchInput', col: '12', information: { label: '{{lang}}Make as default workflow', hint: 'If you turn on the option, this workflow will be used as the default workflow of the frames.', default: false, required: false } },
            { key: 'reusable', type: 'SwitchInput', col: '12', information: { label: '{{lang}}Can be used in other frames too', hint: 'If you turn on the option, this workflow can be used by other frames of this applet. Admins of other frames can add this workflow to their frames.', default: false, required: false } },
        ],

        automationInfoHeaders: [
            { key: 'name', type: 'TextInput', information: { label: '{{lang}}Name', placeholder: '{{lang}}ca.name', hint: "{{lang}}This workflow will be called by this name in the platform", required: true } },
        ],

    }


    componentDidMount() {
        this.init()

        this.props.setHeader({
            'toolbar': null,
            'showToolbar': false,
            'title': translate("Automation information"),
            isPortal: true,
            doNotshowNotification: true,

            topHeaderComponent: this.topHeaderComponent,
            // headerIdentityComponent: this.headerIdentityComponent,
            backAction: () => this.props.lastStage()
        })

    }


    topHeaderComponent = () => {
        return (
            <div className='flexc'>

                <ButtonAnimated
                    iconwidth='24px'
                    onClick={this.state.isLoading ? () => { } : () => this.postAutomation()}
                    title={translate("Create")}
                    icon='/assets/icons/angle-right-white2.svg'
                    textColor={'#222'}
                    isLoading={this.state.isLoading}
                    invert={!this.props.colors?.iconInvert}
                    bg={this.props.colors?.iconInvert ? '#000' : '#fff'}
                />

            </div>

        )
    }


    postAutomation = () => {
        let form = this.infoForm.getForm()

        // console.log(form)
        if (form) {
            this.props.setData(form,()=>{

                this.props.postAutomation()

            })

        }

    }

    init = () => {

        // console.log(this.props.variables)
        let body = {
            appletHub: this.props.variables?.appletHub?._id ?? this.props.variables?.appletHub,
            type: 'workflow'
        }

        // console.log(body)

        this.setState({ isLoadingHubTemplates: true })

        HttpServices.request('getAutomations', body, (fetchResult, fetchError) => {

            this.setState({ isLoadingHubTemplates: false })

            if (fetchError) {
                this.props.actions.addNotif({ type: 'error', title: '{{lang}}errors.loadDataFailed', description: fetchError.message })
                return
            }

            // console.log(fetchResult)

            this.setState({ hubTemplates: fetchResult.info })

        })
    }

    continueScratch = (item) => {

        let type = item.value

        let data = this.props.initData
        if (!data.collectionInfo) {
            data.collectionInfo = {}
        }
        data.collectionInfo.workflowMode = type
        data.collectionInfo.workflowId = null


        this.props.setData(data, () => {

            this.props.continue('template')

        })

    }



    render() {
        return (

            <div className='w-100'>
                <div className='px-1 flexcc' style={{}}>
                    <div className='px-4 mt-2 pt-3' style={{ position: 'relative' }}>
                        <div>
                            <div className='d-flex flex-wrap mt-3' style={{ maxWidth: 600 }}>
                                <div className='px-3 mb-3'>
                                    <h2 className="text-semibig mb-0  color-dark-blue-1" style={{}} >{translate('Workflow information')}</h2>
                                    <p className="mt-0 text-smaller mt-1 mb-0  " style={{ color: '#212529' }} >{translate('You will see your applet with these data that you provide. You can change them later')}</p>
                                </div>
                                <FormViewer ref={el => this.infoForm = el} headers={this.props.initData?.type == 'workflow' ? this.state.workflowInfoHeaders : this.state.automationInfoHeaders} initData={this.props.initData} errors={this.state.errors} formClass={"bordered-form"} inputClass={'bordered-input'} variables={this.props.variables} />
                            </div>
                        </div>
                    </div>
                </div>

            </div>
        )
    }
}

// export default AutomationInfo;
const mapStateToProps = state => ({ settings: state.settings, user: state.user, connections: state.connections })
const mapDispatchToProps = dispatch => ({ actions: bindActionCreators(actions, dispatch) })

export default connect(
    mapStateToProps,
    mapDispatchToProps,
    null,
    { forwardRef: true }
)(AutomationInfo);